export default __webpack_public_path__ + "static/media/blurred_unblurred_hidef.809a142b.PNG";